<template>
  <div class="distribution-intro">
    <div class="input-wrapper hd">
      <div class="input-box">
        <span class="name">
          标题名称：
        </span>
        <div class="input">
          <el-input v-model="condition.title" clearable placeholder="请输入" />
        </div>
      </div>
      <div class="input-box">
        <span class="name">
          页面类型：
        </span>
        <div class="input">
          <el-select
            v-model="condition.pageType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in filterDownData('pageType')"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </div>
      </div>
      <div class="input-box datepicks">
        <span class="name">
          发布时间：
        </span>
        <div class="input">
          <el-date-picker
            v-model="condition.time"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            clearable
          />
        </div>
      </div>
      <el-button
        @click="searchData"
        size="60"
        class="iconfont icon-sousuo"
        round
      />
    </div>
    <div class="table-wrapper">
      <div class="btn-all">
        <el-button
          size="98"
          class="del-color"
          @click="handleSelectionDel"
          v-permission:del="$route.meta.permission"
          v-html="'删除'"
        />
      </div>
      <el-table
        v-min-height
        :data="tableData"
        @selection-change="handleSelectionChange"
        header-cell-class-name="theader-th"
        cell-class-name="tbody-td"
      >
        <el-table-column fixed type="selection" align="center" width="130" />
        <el-table-column align="center" lable="视频/海报图" min-width="180">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.imgUrl"
              :preview-src-list="[scope.row.imgUrl]"
              class="material-img"
            >
              <div slot="error" class="image-slot">
                <i class="iconfont icon-tupian"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="pageType"
          align="center"
          label="页面类型"
          min-width="180"
        />
        <el-table-column
          prop="title"
          align="center"
          label="标题名称"
          min-width="180"
        />
        <el-table-column
          prop="pageAddress"
          align="center"
          label="页面小程序地址"
          min-width="180"
        />
        <el-table-column
          prop="sort"
          align="center"
          label="页面排序"
          min-width="180"
        />
        <el-table-column
          prop="openNum"
          align="center"
          label="打开次数"
          min-width="180"
        />
        <el-table-column
          prop="addTime"
          align="center"
          label="发布时间"
          min-width="180"
        />
        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          min-width="180"
          class-name="visible"
        >
          <template slot-scope="scope">
            <el-button
              size="36"
              v-permission:editor="$route.meta.permission"
              @click="jumpRoute(scope.row)"
              class="iconfont icon-bianji sub-color"
              round
            />
            <el-button
              size="36"
              v-permission:del="$route.meta.permission"
              class="iconfont icon-shanchu del-color"
              @click="handleDelete(scope.$index, scope.row)"
              round
            />
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        ref="pagination"
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize"
      />
      <el-button
        size="220"
        round
        class="iconfont icon-xinzeng"
        @click="jumpRoute"
      >
        发布新页面
      </el-button>
    </div>
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import tableOpearting from 'mixins/tableOpearting/'
import filterDownData from 'mixins/filterDownData'
import { createNamespacedHelpers } from 'vuex'

const { mapMutations } = createNamespacedHelpers('distributionIntro')

export default {
  name: 'distributionIntro',
  mixins: [pickerOptions, tableOpearting, filterDownData],
  data() {
    this.type = 'pagination'
    this.keyMap = {
      articles_list: {
        name: 'tableData',
        article_image: 'img',
        article_adv: 'video',
        article_id: 'id',
        add_time: 'addTime',
        title_name: 'title',
        content_description: 'content',
        sort: 'sort',
        article_url: 'pageAddress',
        read_number: 'openNum',
        article_state: 'articleState',
        type_name: 'pageType'
      }
    }
    return {
      pagination: {
        currentPage: 1,
        recordTotal: 2,
        pageTotal: 20
      },
      condition: {},
      tableData: []
    }
  },
  created() {
    this._getDistributionIntroList({
      curpage: 1
    })
  },
  methods: {
    ...mapMutations({
      saveDistributionIntro: 'CHANGE_DISTRIBUTIONINTRO'
    }),
    /**
     * 跳转分销介绍详情
     * @param row
     */
    jumpRoute(row) {
      const data = {
        name: 'addDistributionIntro',
        query: {
          title: '新增'
        }
      }
      if (row.id) {
        data.query = {
          title: row.pageType,
          id: row.id
        }
        this.saveDistributionIntro(row)
      }
      this.$router.push(data)
    },
    /**
     * 获取列表
     * @param params
     * @private
     */
    _getDistributionIntroList(params) {
      this.api.getDistributionIntroList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchCondition()
      this._getDistributionIntroList({
        ...condition
      })
    },
    /**
     * 分页
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const condition = this._returnSearchCondition()
      this._getDistributionIntroList({
        ...condition,
        curpage: newValue,
        pageSize: size
      })
    },

    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchCondition() {
      const { title, pageType, time } = this.condition
      const data = {
        add_time: time,
        title_name: title,
        type_name: pageType
      }
      this.utils._checkSearchCondition(data)
      return data
    },
    /**
     * 单行删除请求
     * @params rows
     * @private
     */
    delRows(rows) {
      return this.api
        .delDistributionIntroItem({
          article_id: rows.id,
          article_state: 2
        })
        .then(res => {
          this.$notify({
            type: 'success',
            message: '删除成功~！🙂'
          })
        })
    },
    /**
     * 多行删除请求
     * @private
     */
    _multipleDel() {
      const idAll = this.multipleSelection.map(v => {
        return v.id
      })
      return this.delRows({
        id: idAll.join(',')
      })
    }
  }
}
</script>
